<template>
    <div>
        <DocInfo class="pc"></DocInfo>
        <XInfo class="mobile"></XInfo>
    </div>
</template>
<script>
import DocInfo from '@/pages/docInfo/DocInfo.vue'
import xInfo1 from '@/pages/xInfo1/xInfo1.vue'

export default {
  name: 'app',
  components: {
    DocInfo:DocInfo,
    XInfo:xInfo1,
  }
}
</script>